import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeleteReportTemplateState {
  isLoading: boolean
  error: boolean
  httpStatus: number
}

const initialState: DeleteReportTemplateState = {
  isLoading: false,
  error: false,
  httpStatus: 0
}

const deleteReportTemplateSlice = createSlice({
  name: 'deleteReportTemplateSlice',
  initialState,
  reducers: {
    deleteReportTemplateLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        httpStatus: 0
      }
    },
    deleteReportTemplateUpdateAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: false,
        httpStatus: action.payload
      }
    },
    deleteReportTemplateErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  deleteReportTemplateLoadingAction,
  deleteReportTemplateUpdateAction,
  deleteReportTemplateErrorAction
} = deleteReportTemplateSlice.actions

export default deleteReportTemplateSlice.reducer
